import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  TemplateRef
} from '@angular/core';
import { TooltipOptions, TOOLTIP_OPTIONS } from '../../models/tooltip-options';
import { PositionService } from '../../services/position.service';

@Component({
  selector: 'muni-gameday-tooltip-container',
  templateUrl: './tooltip-container.template.html',
  styleUrls: ['./tooltip-container.styles.scss']
})
export class TooltipContainerComponent implements AfterViewInit {
  public classMap: any;
  public top = '-1000px';
  public left = '-1000px';
  public display = 'block';
  public content: string;
  public htmlContent: string | TemplateRef<any>;
  private placement: string;
  private popupClass: string;
  private animation: boolean;
  private appendToBody: boolean;
  private hostEl: ElementRef;
  public context: any;

  public constructor(
    private element: ElementRef,
    private cdr: ChangeDetectorRef,
    private positionService: PositionService,
    @Inject(TOOLTIP_OPTIONS) options: TooltipOptions
  ) {
    Object.assign(this, options);
    this.classMap = { in: false, fade: false };
    this.classMap[options.placement] = true;
    this.classMap['tooltip-' + options.placement] = true;
  }

  public ngAfterViewInit(): void {
    const position = this.positionService.positionElements(
      this.hostEl.nativeElement,
      this.element.nativeElement.children[0],
      this.placement,
      this.appendToBody
    );
    this.top = `${position.top}px`;
    this.left = `${position.left}px`;
    this.classMap.in = true;
    if (this.animation) {
      this.classMap.fade = true;
    }

    if (this.popupClass) {
      this.classMap[this.popupClass] = true;
    }

    this.cdr.detectChanges();
  }

  public get isTemplate(): boolean {
    return this.htmlContent instanceof TemplateRef;
  }
}
